import { Component, HostListener, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BsModalRef, ModalDirective } from 'ngx-bootstrap/modal';
import { HttpService } from 'src/app/services/http.service';
import { Projet } from '../../bo/projet';
import { WorkflowModele } from '../../bo/workflowModele';
import { LocalizedDatePipe } from '../../pipes/localized-date.pipe';
import { FonctionsService } from '../../services/fonctions-partagees.service';

@Component({
  selector: 'app-projet-modale',
  templateUrl: './projet-modale.component.html',
  styleUrls: ['./projet-modale.component.scss'],
  standalone: false
})
export class ProjetModaleComponent {
  @ViewChild('modalConfirmSuppr') modalConfirmSuppr: ModalDirective;
  @ViewChild('modalConfirmCancel') modalConfirmCancel: ModalDirective;
  siteId: number;
  projet: Projet;
  projetSauv: Projet;
  modalRef: BsModalRef;
  success = false;
  nomInvalide = false;
  datesPrevNonChonologiques = false;
  datesEffNonChonologiques = false;
  datePrevDebInvalide = false;
  datePrevFinInvalide = false;
  dateEffFinInvalide = false;
  workflowInvalide = false;
  dateEffDebSupTirs: string = null;
  dateEffFinInfTirs: string = null;
  annul = false;
  estModif = false;
  suppression = false;
  workflows: WorkflowModele[];
  workflowSelectionne: WorkflowModele;
  dateDebutPrev: Date;
  erreurApi: boolean;

  constructor(private readonly bsModalRef: BsModalRef, private readonly http: HttpService,
    private readonly fonctionsService: FonctionsService, private readonly translate: TranslateService, private readonly localizedDatePipe: LocalizedDatePipe) {
  }

  ngOnInit() {
    this.projetSauv = new Projet();
    if (!this.estModif) {
      this.projet = new Projet();
      this.dateDebutPrev = new Date();
      this.projet.dateDebutPrevisionnelle = this.dateDebutPrev;
      this.projet.projetId = -1;
      this.projet.siteId = this.siteId;
      this.workflowSelectionne = null;
    } else {
      Object.assign(this.projetSauv, this.projet);
      this.projet.dateDebutPrevisionnelle = this.fonctionsService.normalisationDateTime(this.projet.dateDebutPrevisionnelle, 0);
      this.projet.dateFinPrevisionnelle = this.fonctionsService.normalisationDateTime(this.projet.dateFinPrevisionnelle, 0);
      this.projet.dateFinEffective = this.fonctionsService.normalisationDateTime(this.projet.dateFinEffective, 0);
      this.projet.dateDebutEffective = this.fonctionsService.normalisationDateTime(this.projet.dateDebutEffective, 0);
    }
  }

  @HostListener('window:keydown.esc', ['$event'])
  onEsc(event: any): void {
    if (event.keyCode === 27) {
      event.preventDefault();
    }
    this.showModalCancel();
  }

  onSubmit() {
    this.erreurApi = false;
    if (this.validationFormulaire()) {
      this.fonctionsService.loading_screen(true);
      if (!this.estModif || (this.estModif && this.workflowSelectionne)) {
        this.projet.workflowModele = this.workflowSelectionne;
        this.projet.workflowModeleID = this.workflowSelectionne.workflowModeleId;
      }

      this.projet.nom = this.projet.nom.trim();
      let requete = this.estModif ? this.http.put<Projet, Projet>('Projects', this.projet) :
        this.http.post<Projet, Projet>('Projects', this.projet);

      requete.subscribe(resultat => {
        if (resultat) {
          this.projet = resultat;
          this.success = true;
        }
        else
          this.erreurApi = true;
        this.fonctionsService.loading_screen(false);
        if (!this.erreurApi) {
          this.fonctionsService.launch_toast(this.success);
          this.bsModalRef.hide();
        }
      }, () => {
        this.erreurApi = true;
        this.fonctionsService.loading_screen(false);
      });
    }
  }

  validationFormulaire() {
    this.projet.dateDebutPrevisionnelle = this.fonctionsService.normalisationDate(this.projet.dateDebutPrevisionnelle);
    this.projet.dateFinPrevisionnelle = this.fonctionsService.normalisationDate(this.projet.dateFinPrevisionnelle);
    this.projet.dateDebutEffective = this.fonctionsService.normalisationDate(this.projet.dateDebutEffective);
    this.projet.dateFinEffective = this.fonctionsService.normalisationDate(this.projet.dateFinEffective);

    this.nomInvalide = this.fonctionsService.stringEstVide(this.projet.nom);
    this.datePrevDebInvalide = !this.projet.dateDebutPrevisionnelle;
    this.datePrevFinInvalide = !this.projet.dateFinPrevisionnelle;
    this.datesPrevNonChonologiques = !this.datePrevDebInvalide && !this.datePrevFinInvalide && this.projet.dateDebutPrevisionnelle > this.projet.dateFinPrevisionnelle;
    this.dateEffFinInvalide = this.projet.dateFinEffective && !this.projet.dateDebutEffective;
    this.datesEffNonChonologiques = !this.dateEffFinInvalide && this.projet.dateDebutEffective && this.projet.dateFinEffective && this.projet.dateDebutEffective > this.projet.dateFinEffective;
    this.workflowInvalide = !this.estModif && (this.workflowSelectionne == null || this.workflowSelectionne.workflowModeleId == null);

    this.dateEffDebSupTirs = null;
    this.dateEffFinInfTirs = null;
    let dateDebEff = this.fonctionsService.normalisationDate(this.projet.dateDebutEffective);
    let dateFinEff = this.fonctionsService.normalisationDate(this.projet.dateFinEffective);
    if (this.projet.tirs && this.projet.tirs.length > 0) {
      this.projet.tirs.forEach(tir => {
        if (dateDebEff && tir.dateTirEffective && dateDebEff > new Date(tir.dateTirEffective)) {
          this.translate.get('MODALE_PROJET.DATE_EFF_DEB_SUP_TIRS', { nomTir: tir.nom, dateTir: this.localizedDatePipe.transform(tir.dateTirEffective) }).subscribe((res: string) => {
            this.dateEffDebSupTirs = res;
          });
        }
        if (dateFinEff && tir.dateTirEffective && dateFinEff < new Date(tir.dateTirEffective)) {
          this.translate.get('MODALE_PROJET.DATE_EFF_FIN_INF_TIRS', { nomTir: tir.nom, dateTir: this.localizedDatePipe.transform(tir.dateTirEffective) }).subscribe((res: string) => {
            this.dateEffFinInfTirs = res;
          });
        }
      });
    }

    return !this.nomInvalide && !this.datePrevDebInvalide && !this.datePrevFinInvalide && !this.datesPrevNonChonologiques && !this.dateEffFinInvalide
      && !this.datesEffNonChonologiques && !this.workflowInvalide && !this.dateEffDebSupTirs && !this.dateEffFinInfTirs;
  }

  delete() {
    this.fonctionsService.loading_screen(true);
    this.suppression = true;
    this.http.delete('Projects/' + this.projet.projetId).subscribe(res => {
      if (res)
        this.success = true;
      else
        this.erreurApi = false;

      this.fonctionsService.loading_screen(false);
      if (!this.erreurApi) {
        this.fonctionsService.launch_toast(this.success, true);
        this.bsModalRef.hide();
      }
    }, () => {
      this.erreurApi = true;
      this.fonctionsService.loading_screen(false);
    });
  }

  nettoyerDates(field: 'dateDebutPrevisionnelle' | 'dateFinPrevisionnelle' | 'dateDebutEffective' | 'dateFinEffective') {
    this.projet[field] = null;
  }

  showModalCancel() {
    if (this.diff()) {
      this.modalConfirmCancel.show();
    } else {
      this.annulModif();
    }
  }

  diff() {
    if (this.estModif) {
      let dateDebPrevModif = false;
      let dateFinPrevModif = false;
      let dateDebEffModif = false;
      let dateFinEffModif = false;

      if ((!this.projet.dateDebutPrevisionnelle && this.projetSauv.dateDebutPrevisionnelle) ||
        (this.projet.dateDebutPrevisionnelle && !this.projetSauv.dateDebutPrevisionnelle) ||
        this.projet.dateDebutPrevisionnelle &&
        (this.projet.dateDebutPrevisionnelle.getDay() !== this.projetSauv.dateDebutPrevisionnelle.getDay() ||
          this.projet.dateDebutPrevisionnelle.getMonth() !== this.projetSauv.dateDebutPrevisionnelle.getMonth() ||
          this.projet.dateDebutPrevisionnelle.getFullYear() !== this.projetSauv.dateDebutPrevisionnelle.getFullYear()))
        dateDebPrevModif = true;
      if ((!this.projet.dateFinPrevisionnelle && this.projetSauv.dateFinPrevisionnelle) ||
        (this.projet.dateFinPrevisionnelle && !this.projetSauv.dateFinPrevisionnelle) ||
        this.projet.dateFinPrevisionnelle &&
        (this.projet.dateFinPrevisionnelle.getDay() !== this.projetSauv.dateFinPrevisionnelle.getDay() ||
          this.projet.dateFinPrevisionnelle.getMonth() !== this.projetSauv.dateFinPrevisionnelle.getMonth() ||
          this.projet.dateFinPrevisionnelle.getFullYear() !== this.projetSauv.dateFinPrevisionnelle.getFullYear()))
        dateFinPrevModif = true;
      if ((!this.projet.dateDebutEffective && this.projetSauv.dateDebutEffective) ||
        (this.projet.dateDebutEffective && !this.projetSauv.dateDebutEffective) ||
        this.projet.dateDebutEffective &&
        (this.projet.dateDebutEffective.getDay() !== this.projetSauv.dateDebutEffective.getDay() ||
          this.projet.dateDebutEffective.getMonth() !== this.projetSauv.dateDebutEffective.getMonth() ||
          this.projet.dateDebutEffective.getFullYear() !== this.projetSauv.dateDebutEffective.getFullYear()))
        dateDebEffModif = true;
      if ((!this.projet.dateFinEffective && this.projetSauv.dateFinEffective) ||
        (this.projet.dateFinEffective && !this.projetSauv.dateFinEffective) ||
        this.projet.dateFinEffective &&
        (this.projet.dateFinEffective.getDay() !== this.projetSauv.dateFinEffective.getDay() ||
          this.projet.dateFinEffective.getMonth() !== this.projetSauv.dateFinEffective.getMonth() ||
          this.projet.dateFinEffective.getFullYear() !== this.projetSauv.dateFinEffective.getFullYear()))
        dateFinEffModif = true;

      return this.projet.nom !== this.projetSauv.nom ||
        dateDebPrevModif || dateFinPrevModif ||
        dateDebEffModif || dateFinEffModif ||
        this.workflowSelectionne;
    } else {
      let dateDebPrevModif = false;
      if (!this.projet.dateDebutPrevisionnelle ||
        this.projet.dateDebutPrevisionnelle.getDay() !== this.dateDebutPrev.getDay() ||
        this.projet.dateDebutPrevisionnelle.getMonth() !== this.dateDebutPrev.getMonth() ||
        this.projet.dateDebutPrevisionnelle.getFullYear() !== this.dateDebutPrev.getFullYear())
        dateDebPrevModif = true;

      return this.projet.nom ||
        dateDebPrevModif ||
        this.projet.dateFinPrevisionnelle ||
        this.projet.dateDebutEffective ||
        this.projet.dateFinEffective ||
        this.workflowSelectionne;
    }
  }

  hideModalConfirm() {
    this.modalConfirmCancel.hide();
  }

  annulModif() {
    this.annul = true;
    this.bsModalRef.hide();
  }
}
